import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  DatesDetailPage,
  DatesEdit,
  DatesParticipantsPage,
  DatesPage,
  EventsDetailPage,
  EventsEdit,
  EventsPage,
  WorkshopsDetailPage,
  WorkshopsEdit,
  WorkshopsPage,
} from '../pages/CMSPages/index';
import React from 'react';

const FriOpenRoutes = () => (
  <>
    <Route
      path={routes.cmsFoEventsList}
      element={
        <CMSWrapper permissions={['fo-events.index']}>
          <EventsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoEventsCreate}
      element={
        <CMSWrapper permissions={['fo-events.store']}>
          <EventsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoEventsEdit(':eventId')}
      element={
        <CMSWrapper permissions={['fo-events.update']}>
          <EventsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoEventsDetail(':eventId')}
      element={
        <CMSWrapper permissions={['fo-events.show']}>
          <EventsDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoEventsUnarchive(':eventId')}
      element={
        <CMSWrapper permissions={['fo-events.update']}>
          <EventsEdit mode={'unarchive'} />
        </CMSWrapper>
      }
    />
    {/* FRI.open - workshops */}
    <Route
      path={routes.cmsFoWorkshopsList(':eventId')}
      element={
        <CMSWrapper permissions={['fo-workshops.index']}>
          <WorkshopsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoWorkshopsCreate(':eventId')}
      element={
        <CMSWrapper permissions={['fo-workshops.store']}>
          <WorkshopsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoWorkshopsEdit(':workshopId')}
      element={
        <CMSWrapper permissions={['fo-workshops.update']}>
          <WorkshopsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoWorkshopsDetail(':workshopId')}
      element={
        <CMSWrapper permissions={['fo-workshops.show']}>
          <WorkshopsDetailPage />
        </CMSWrapper>
      }
    />
    {/* FRI.open - dates */}
    <Route
      path={routes.cmsFoDatesList(':workshopId')}
      element={
        <CMSWrapper permissions={['fo-dates.index']}>
          <DatesPage mode={'workshop'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoMyDatesList}
      element={
        <CMSWrapper permissions={['fo-dates.index']}>
          <DatesPage mode={'my'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoDatesCreate(':workshopId')}
      element={
        <CMSWrapper permissions={['fo-dates.store']}>
          <DatesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoDatesEdit(':dateId')}
      element={
        <CMSWrapper permissions={['fo-dates.update']}>
          <DatesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoDatesDetail(':dateId')}
      element={
        <CMSWrapper permissions={['fo-dates.show']}>
          <DatesDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFoDateParticipants(':dateId')}
      element={
        <CMSWrapper permissions={['fo-dates.show']}>
          <DatesParticipantsPage />
        </CMSWrapper>
      }
    />
  </>
);

export default FriOpenRoutes;
